import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, CheckCircle, Users, BarChart, Award } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
export function SponsorshipPage() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mzzjzkpj');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    sponsorshipLevel: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const sponsorshipLevels = [{
    title: 'Platinum',
    price: '$10,000',
    benefits: ['Premier logo placement on all event materials', 'Speaking opportunity', '1 complimentary event pass', 'Access to attendee list with contact information', 'Featured in post-event recap materials', 'Opportunity to provide branded gift items']
  }, {
    title: 'Gold',
    price: '$5,000',
    benefits: ['Prominent logo placement on event materials', '1 complimentary event pass', 'Access to attendee list (name and company only)', 'Mentioned in post-event recap materials']
  }, {
    title: 'Silver',
    price: '$2,500',
    benefits: ['Logo on event materials', 'Company mentioned during event']
  }];
  return <div className="w-full min-h-screen bg-[#FFF8DC]" data-id="element-297" data-mp="1tvu1m94tfc9d">
      <Header data-id="element-298" data-mp="1ovxtbxp34yo0" />
      <main data-id="element-299" data-mp="1owhedna18369">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-[#2F1B10]" data-id="element-300" data-mp="1oxionpj84lmx">
          <div className="absolute inset-0 z-0 opacity-30" data-id="element-301" data-mp="1jx4jcf90bpsl">
            <img src="https://images.unsplash.com/photo-1544025162-d76694265947?w=2070&q=80" alt="Austin BBQ" className="w-full h-full object-cover" data-id="element-302" data-mp="1jypbxzbrgynt" />
          </div>
          <div className="container relative z-10 mx-auto px-4 md:px-6 text-white" data-id="element-303" data-mp="1a8z489dpagcg">
            <div className="max-w-3xl" data-id="element-304" data-mp="w9hf1swht12k">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-305" data-mp="waj10sf1r7z2">
                Sponsorship Opportunities
              </h1>
              <p className="text-xl md:text-2xl font-light mb-8 text-[#FFF8DC]" data-id="element-306" data-mp="1t09tkm3s2l28">
                Connect your brand with top ecommerce CFOs at the Commerce CFO
                Roundtable - Austin
              </p>
              <a href="#sponsorship-packages" className="inline-flex items-center gap-2 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold px-6 py-3 rounded-md transition-colors shadow-lg" data-id="element-307" data-mp="1j8vpe10vsx2r">
                View Sponsorship Packages
                <ChevronRight size={18} data-id="element-308" data-mp="ar1qmxn4yxo" />
              </a>
            </div>
          </div>
        </section>
        {/* Benefits Section */}
        <section className="py-20 bg-[#FFF8DC]" data-id="element-309" data-mp="3rh0ur1sl5o1d">
          <div className="container mx-auto px-4 md:px-6" data-id="element-310" data-mp="a0sqzi1qcne6">
            <div className="text-center mb-16" data-id="element-311" data-mp="a0aklslcsssj">
              <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-312" data-mp="51fwcb4mac11">
                Why Sponsor the Commerce CFO Roundtable?
              </h2>
              <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-313" data-mp="3ng8maarjfn65"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto" data-id="element-314" data-mp="3igm73vs5fwup">
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-315" data-mp="12p83nxxe2tmc">
                <div className="flex justify-center mb-4" data-id="element-316" data-mp="xrg189z4bp3w">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-317" data-mp="xszhw1oos267">
                    <Users className="text-[#D2691E]" size={32} data-id="element-318" data-mp="33h9v8z310oeu" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-319" data-mp="3cfvdet4l61f3">
                  Exclusive Access
                </h3>
                <p className="text-[#556B2F]" data-id="element-320" data-mp="3hfrkx2chsaze">
                  Connect directly with 50+ ecommerce CFOs and finance leaders
                  in an intimate Austin setting
                </p>
              </div>
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-321" data-mp="3rbbaz84dkfg8">
                <div className="flex justify-center mb-4" data-id="element-322" data-mp="3w4e81q8d2716">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-323" data-mp="401vqayiqjwg">
                    <BarChart className="text-[#D2691E]" size={32} data-id="element-324" data-mp="8zocgudk2ia0" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-325" data-mp="dyrfyadw0gfv">
                  Brand Visibility
                </h3>
                <p className="text-[#556B2F]" data-id="element-326" data-mp="nzk0q069x32u">
                  Showcase your brand to decision-makers during workshops and
                  the Franklin BBQ dinner
                </p>
              </div>
              <div className="text-center bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#D2691E]" data-id="element-327" data-mp="e5jws1mqa3vp">
                <div className="flex justify-center mb-4" data-id="element-328" data-mp="16seewrw2or60">
                  <div className="bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-329" data-mp="16rw9b4nit0lf">
                    <Award className="text-[#D2691E]" size={32} data-id="element-330" data-mp="11u35ujdlqkou" />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#8B4513] font-serif" data-id="element-331" data-mp="x0i5ikojdemh">
                  Thought Leadership
                </h3>
                <p className="text-[#556B2F]" data-id="element-332" data-mp="1pjfg7mko0ysq">
                  Position your company as a leader in financial innovation and
                  ecommerce strategy
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Sponsorship Packages */}
        <section id="sponsorship-packages" className="py-20 bg-white" data-id="element-333" data-mp="3jyul5dw3giap">
          <div className="container mx-auto px-4 md:px-6" data-id="element-334" data-mp="3k0yn3qafn78c">
            <div className="text-center mb-16" data-id="element-335" data-mp="359gam2gs7utq">
              <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-336" data-mp="3a9b1i60k4kes">
                Sponsorship Packages
              </h2>
              <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-337" data-mp="316jo40o4feki"></div>
              <p className="mt-6 text-lg text-[#556B2F] max-w-2xl mx-auto" data-id="element-338" data-mp="2md6nyqrtdvy4">
                Choose the package that best aligns with your marketing
                objectives and budget
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-339" data-mp="ki62s49ewy5a">
              {sponsorshipLevels.map((level, index) => <div key={index} className="bg-white rounded-lg shadow-xl overflow-hidden border border-[#D2691E]" data-id="element-340" data-mp="2a25y5ftv97wn" data-mpi={index}>
                  <div className="bg-[#2F1B10] text-white p-6 text-center" data-id="element-341" data-mp="2jqntvinagotf">
                    <h3 className="text-2xl font-bold font-serif" data-id="element-342" data-mp="2jt0hocfq9tee">
                      {level.title}
                    </h3>
                    <p className="text-3xl font-bold mt-2 text-[#F4A460]" data-id="element-343" data-mp="2srcbenbw57b2">
                      {level.price}
                    </p>
                  </div>
                  <div className="p-6 bg-[#FFF8DC]" data-id="element-344" data-mp="2opr21bykfb5m">
                    <ul className="space-y-3" data-id="element-345" data-mp="32q1rcak88hoo">
                      {level.benefits.map((benefit, i) => <li key={i} className="flex items-start" data-id="element-346" data-mp="2xrqhw0xug96z" data-mpi={i}>
                          <CheckCircle className="text-[#D2691E] mr-2 shrink-0 mt-1" size={16} data-id="element-347" data-mp="18bipma7iei7p" />
                          <span className="text-[#556B2F]" data-id="element-348" data-mp="13f0nli3kcxz2">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Contact Form */}
        <section id="contact" className="py-20 bg-[#FFF8DC]" data-id="element-349" data-mp="rbeki8t2wrsd">
          <div className="container mx-auto px-4 md:px-6" data-id="element-350" data-mp="w7d3fgvn1hle">
            <div className="max-w-4xl mx-auto" data-id="element-351" data-mp="3uq1wlske0rk2">
              <div className="text-center mb-16" data-id="element-352" data-mp="3urbtwfjf1vpn">
                <h2 className="text-3xl md:text-4xl font-bold text-[#2F1B10] font-serif" style={{
                fontFamily: 'Rockwell, "Courier New", serif'
              }} data-id="element-353" data-mp="3jqwpzr45wub">
                  Become a Sponsor
                </h2>
                <div className="mt-4 w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-354" data-mp="1jxz951i66ps8"></div>
                <p className="mt-6 text-lg text-[#556B2F] max-w-2xl mx-auto" data-id="element-355" data-mp="1k0bp594daq2n">
                  Interested in sponsoring the Commerce CFO Roundtable? Fill out
                  the form below and our team will contact you with more
                  information.
                </p>
              </div>
              {state.succeeded ? <div className="bg-white rounded-lg shadow-xl p-8 text-center border border-[#D2691E]" data-id="element-356" data-mp="2zojeuf9flbya">
                  <div className="mb-6 text-[#556B2F]" data-id="element-357" data-mp="2uqzxv7lcml2n">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-358" data-mp="2uodrvce3wdmj">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-359" data-mp="2gqp7e5nyb8i0" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-[#2F1B10]" data-id="element-360" data-mp="a1amx5nrnjf8">
                    Thank You!
                  </h3>
                  <p className="text-lg mb-6 text-[#556B2F]" data-id="element-361" data-mp="2umxqfxqv3jcn">
                    Your sponsorship inquiry has been received. We will send you
                    event information within 24 hours.
                  </p>
                </div> : <div className="bg-white rounded-lg shadow-xl p-8 border border-[#D2691E]" data-id="element-362" data-mp="2zkz7ye8n3am0">
                  <form onSubmit={handleSubmit} data-id="element-363" data-mp="2btk4gi54mn96">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-364" data-mp="2bs90oibolfi2">
                      <div data-id="element-365" data-mp="26wtp5x15bvot">
                        <label htmlFor="name" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-366" data-mp="26tfkuj8x9ceq">
                          Full Name*
                        </label>
                        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-367" data-mp="1s4t2e8o004ja" />
                        <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-368" data-mp="192smuasb0z6z" />
                      </div>
                      <div data-id="element-369" data-mp="21pwny4oa0tdh">
                        <label htmlFor="company" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-370" data-mp="21o2atcj8y5jy">
                          Company*
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-371" data-mp="bcnxkatry78m" />
                        <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-372" data-mp="24a1oj8drswcq" />
                      </div>
                      <div data-id="element-373" data-mp="1vc96hwgnzaln">
                        <label htmlFor="email" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-374" data-mp="1qatko26nx027">
                          Email Address*
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-375" data-mp="3kmqhybrsd056" />
                        <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-376" data-mp="5s9bim04h2ut" />
                      </div>
                      <div data-id="element-377" data-mp="39bkpm7mlis2p">
                        <label htmlFor="phone" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-378" data-mp="3e8b4irmnzhmj">
                          Phone Number*
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-379" data-mp="yhomjbrsevqq" />
                        <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-380" data-mp="1147h0l0864vy" />
                      </div>
                      <div className="md:col-span-2" data-id="element-381" data-mp="1orpbwpesdj35">
                        <label htmlFor="sponsorshipLevel" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-382" data-mp="1or7897pso2l7">
                          Interested Sponsorship Level
                        </label>
                        <select id="sponsorshipLevel" name="sponsorshipLevel" value={formData.sponsorshipLevel} onChange={handleChange} className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" data-id="element-383" data-mp="1tsd43eer45yy">
                          <option value="" data-id="element-384" data-mp="1tomf9slaiv2y">Select a sponsorship level</option>
                          <option value="Platinum" data-id="element-385" data-mp="1tmhzaca4a5mb">Platinum ($10,000)</option>
                          <option value="Gold" data-id="element-386" data-mp="1ygw04u7jt4yd">Gold ($5,000)</option>
                          <option value="Silver" data-id="element-387" data-mp="1kopjz84eaxyx">Silver ($2,500)</option>
                          <option value="Custom" data-id="element-388" data-mp="1pn0vdnac9gj9">Custom Package</option>
                        </select>
                        <ValidationError prefix="Sponsorship Level" field="sponsorshipLevel" errors={state.errors} data-id="element-389" data-mp="1aq0bg5ye2pvc" />
                      </div>
                      <div className="md:col-span-2" data-id="element-390" data-mp="wkzxo6sii14c">
                        <label htmlFor="message" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-391" data-mp="rtrpfe2x4lsr">
                          Additional Information
                        </label>
                        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="Please share any specific interests or questions you have about sponsorship opportunities." data-id="element-392" data-mp="1fj2ie9e11bwc"></textarea>
                        <ValidationError prefix="Message" field="message" errors={state.errors} data-id="element-393" data-mp="3ledn7bd58ymi" />
                      </div>
                    </div>
                    <div className="mt-8" data-id="element-394" data-mp="2ar4qu7ygbyk8">
                      <button type="submit" disabled={state.submitting} className="w-full bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 disabled:opacity-70" data-id="element-395" data-mp="2aqcw0zcoi4v0">
                        {state.submitting ? 'Submitting...' : 'Submit Inquiry'}
                      </button>
                    </div>
                    <ValidationError errors={state.errors} data-id="element-396" data-mp="2ygfnpecol8t3" />
                  </form>
                </div>}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-397" data-mp="142xxtkoszzuw" />
    </div>;
}